export const localVoicesBlacklist = [
  'Majed',
  'Daria',
  'Montse',
  'Li-Mu',
  'Lana',
  'Sara',
  'Ellen',
  'Xander',
  'Eddy',
  'Flow',
  'Reed',
  'Rocko',
  'Sandy',
  'Shelley',
  'Flo',
  'Jacques',
  'Thomas',
  'Anna',
  'Damayanti',
  'Alice',
  'Kyoko',
  'Yuna',
  'Nora',
  'Zosia',
  'Luciana',
  'Ioana',
  'Paulina',
  'Alva',
  'Kanya',
  'Yelda',
  'Lesya',
  'Linh',
  'Microsoft Adri',
  'Microsoft Willem',
  'Microsoft Anima',
  'Microsoft Ismael',
  'Microsoft Laila',
  'Microsoft Salma',
  'Microsoft Shakir',
  'Microsoft Taim',
  'Microsoft Fahed',
  'Microsoft Noura',
  'Microsoft Abdullah',
  'Microsoft Aysha',
  'Microsoft Amal',
  'Microsoft Moaz',
  'Microsoft Hamed',
  'Microsoft Zariyah',
  'Microsoft Hedi',
  'Microsoft Reem',
  'Microsoft Fatima',
  'Microsoft HiuMaan',
  'Microsoft Xiaoxiao',
  'Microsoft Yunxi',
  'Microsoft Xiaobei',
  'Microsoft Xiaoni',
  'Microsoft Vlasta',
  'Microsoft Colette',
  'Microsoft Angelo',
  'Microsoft Gerard',
  'Microsoft Antonie',
  'Microsoft Jean',
  'Microsoft Denise',
  'Microsoft Conrad',
  'Microsoft Leni',
  'Microsoft Eka',
  'Microsoft Giorgi',
  'Microsoft Athina',
  'Microsoft Avri',
  'Microsoft Hemant',
  'Microsoft Kalpana',
  'Microsoft Diego',
  'Microsoft Keita',
  'Microsoft Aigul',
  'Microsoft Hyunsu Multilingual',
  'Microsoft SunHi',
  'Microsoft Osman',
  'Microsoft Yasmin',
  'Microsoft Dilara',
  'Microsoft Farid',
  'Microsoft Duarte',
  'Microsoft Raquel',
  'Microsoft Alina',
  'Microsoft Emil',
  'Microsoft Rok',
  'Microsoft Thilini',
  'Microsoft Tomas',
  'Microsoft Gonzalo',
  'Microsoft Salome',
  'Microsoft Maria',
  'Microsoft Belkys',
  'Microsoft Manual',
  'Microsoft Andrea',
  'Microsoft Luis',
  'Microsoft Roberto',
  'Microsoft Mario',
  'Microsoft Alex',
  'Microsoft Elvira',
  'Microsoft Mateo',
  'Microsoft Zuri',
  'Microsoft Valluvar',
  'Microsoft Surya',
  'Microsoft Kumar',
  'Microsoft Mohan',
  'Microsoft Emel',
  'Microsoft Gul',
  'Microsoft HoaiMy',
  'Microsoft Illir',
  'Microsoft Babek',
  'Microsoft Banu',
  'Microsoft Vesna',
  'Microsoft Thiha',
  'Microsoft Siqiniq',
  'Microsoft Taqqiq',
  'Microsoft Siqiniq',
  'Microsoft Taqqiq',
  'Microsoft Dimas',
  'Microsoft Sapna',
  'Microsoft Chanthavong',
  'Microsoft Keomany',
  'Microsoft Midhun',
  'Microsoft Bataa',
  'Microsoft Yesui',
  'Microsoft GulNawaz',
  'Microsoft Lartifa'
];
